import logo from "../assets/images/logo.png";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <div className="w-full bg-gray-900 shadow-lg border-b-4 border-gray-800">
      <div className="sm:flex sm:items-center sm:w-[90%] sm:ml-auto sm:mr-auto sm:justify-between">
        <div className="flex justify-center py-2 h-16 sm:h-20 object-contain">
          <img src={logo} alt="" />
        </div>
        <div>
          <Link to="/profile">
            <PersonOutlineOutlinedIcon
              fontSize="large"
              className="text-gray-300 cursor-pointer bg-gray-800 border border-gray-700 shadow-2xl hover:bg-gray-300 hover:text-black"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
